import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SyncStatusResult } from '../models/redis-cache.models';

@Injectable({
  providedIn: 'root',
})
export class RedisCacheService {
  private http = inject(HttpClient);

  disableRedisCacheByWebsiteId(websiteId: number): Observable<void> {
    return this.http.patch<void>('/redis-cache/disable', { website_id: websiteId });
  }

  enableRedisCacheByWebsiteId(websiteId: number): Observable<void> {
    return this.http.post<void>('/redis-cache/enable', { website_id: websiteId });
  }

  getRedisCacheStatusByWebsiteId(websiteId: number): Observable<SyncStatusResult> {
    const query = new URLSearchParams();
    query.set('website_id', websiteId.toString());
    query.set('sync', 'false');

    return this.http.get<SyncStatusResult>(`/redis-cache/status?${query.toString()}`);
  }

  getRedisCacheSyncedStatusByWebsiteId(websiteId: number): Observable<void> {
    const query = new URLSearchParams();
    query.set('website_id', websiteId.toString());
    query.set('sync', 'true');

    return this.http.get<void>(`/redis-cache/status?${query.toString()}`);
  }
}
